<div
  class="alert-banner"
  [attr.role]="getRole(alert.severity)"
  [class.alert-banner--critical]="alert.severity === AlertSeverity.CRITICAL"
  [class.alert-banner--warning]="alert.severity === AlertSeverity.WARNING"
  [class.alert-banner--info]="alert.severity === AlertSeverity.INFO">
  <mat-icon class="alert-banner__icon" aria-hidden="true">
    {{ getIcon(alert.severity) }}
  </mat-icon>

  <div class="alert-banner__content">
    <h6 class="alert-banner__title">
      {{ alert.title }}
    </h6>

    <p class="alert-banner__message">
      {{ alert.message }}
    </p>
  </div>

  <button
    mat-icon-button
    type="button"
    class="alert-banner__dismiss"
    aria-label="Dismiss alert"
    (click)="onDismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
